
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ClassMetadata, IInfoCardData, IInfoRowActionCriteria, IInfoTable, IInfoTableActionCriteria, IInfoTableCriteria, IInfoTableRowActionCriteria, InfoTableSaveCriteria } from "@tylertech/tyler-api-types";

/**
 * InfoTableService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class InfoTableService {
    constructor(private readonly $apiService: ApiService) { }
    
    Get(pCriteria: IInfoTableCriteria): Promise<IInfoTable> {
        return this.$apiService.sendAuth("IInfoTableService/Get", pCriteria);
    }
    GetEntityForEdit(pCriteria: IInfoTableCriteria): Promise<any> {
        return this.$apiService.sendAuth("IInfoTableService/GetEntityForEdit", pCriteria);
    }
    GetMetadata(pProviderId: string): Promise<ClassMetadata> {
        return this.$apiService.sendAuth("IInfoTableService/GetMetadata", pProviderId);
    }
    GetSearchRowActions(pCriteria: IInfoTableRowActionCriteria): Promise<IInfoCardData> {
        return this.$apiService.sendAuth("IInfoTableService/GetSearchRowActions", pCriteria);
    }
    PerformAction(pCriteria: IInfoTableActionCriteria): Promise<boolean> {
        return this.$apiService.sendAuth("IInfoTableService/PerformAction", pCriteria);
    }
    PerformRowAction(pCriteria: IInfoRowActionCriteria): Promise<string> {
        return this.$apiService.sendAuth("IInfoTableService/PerformRowAction", pCriteria);
    }
    SaveEntity(pCriteria: InfoTableSaveCriteria): Promise<InfoTableSaveCriteria> {
        return this.$apiService.sendAuth("IInfoTableService/SaveEntity", pCriteria);
    }
}
